// client/src/services/orderTemplatesAPI.js
// ================================================================
// FIXED: Uses centralized API_URL (Port 5000) & getAuthHeaders
// ================================================================

import axios from 'axios';
// ✅ ΔΙΟΡΘΩΣΗ: Import από το κεντρικό service που φτιάξαμε, όχι από config
import { API_URL, getAuthHeaders } from './api';

export const orderTemplatesAPI = {
  // Get all templates for the business
  getAll: async (params = {}) => {
    try {
      const response = await axios.get(`${API_URL}/business/order-templates`, {
        headers: getAuthHeaders(), // ✅ Χρήση του κεντρικού helper
        params
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      throw error;
    }
  },

  // Get single template by ID
  getById: async (templateId) => {
    try {
      const response = await axios.get(`${API_URL}/business/order-templates/${templateId}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching template:', error);
      throw error;
    }
  },

  // Create new template
  create: async (templateData) => {
    try {
      const response = await axios.post(`${API_URL}/business/order-templates`, templateData, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error creating template:', error);
      throw error;
    }
  },

  // Update template
  update: async (templateId, templateData) => {
    try {
      const response = await axios.put(`${API_URL}/business/order-templates/${templateId}`, templateData, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating template:', error);
      throw error;
    }
  },

  // Delete template
  delete: async (templateId) => {
    try {
      const response = await axios.delete(`${API_URL}/business/order-templates/${templateId}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting template:', error);
      throw error;
    }
  },

  // Use template (get items with current prices)
  use: async (templateId) => {
    try {
      const response = await axios.post(`${API_URL}/business/order-templates/${templateId}/use`, {}, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error using template:', error);
      throw error;
    }
  },

  // Duplicate template
  duplicate: async (templateId) => {
    try {
      const response = await axios.post(`${API_URL}/business/order-templates/${templateId}/duplicate`, {}, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error duplicating template:', error);
      throw error;
    }
  }
};

export default orderTemplatesAPI;